module.exports = __webpack_public_path__ + "img/Newbie_Staff_03_Mage.f765762f.png";